"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quote = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Quote = function Quote(_ref) {
  var text = _ref.text,
      style = _ref.style;
  var textProps = style === 'bold' ? {
    bold: true
  } : {
    display: true
  };
  return _react.default.createElement(_styles.Container, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Content, null, _react.default.createElement("blockquote", null, _react.default.createElement(_styles.StartQuoteText, textProps), _react.default.createElement(_styles.QuoteText, textProps, text, _react.default.createElement(_styles.EndQuoteText, textProps)))));
};

exports.Quote = Quote;